import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { Blogs } from "./components/Blogs/BlogListing";
import { CreateEditBlog } from "./components/Blogs/CreateEditBlog";
import { Catalogs } from "./components/Catalogs/Catalogs";
import { CatalogDetails } from "./components/Catalogs/Details/CatalogDetails";
import { AddEditProduct } from "./components/Catalogs/Product/AddEditProduct";
import Category from "./components/Categories/Category";
import CategoryAdd from "./components/Categories/CategoryAdd";
import CategoryUpdate from "./components/Categories/CategoryUpdate";
import ClientAdd from "./components/ClientLogos/ClientAdd";
import ClientLogos from "./components/ClientLogos/ClientLogos";
import ClientUpdate from "./components/ClientLogos/ClientUpdate";
import ClientLogosPage from "./components/ClientLogosPage/ClientLogosPage";
import ClientPageAdd from "./components/ClientLogosPage/ClientPageAdd";
import ClientPageUpdate from "./components/ClientLogosPage/ClientPageUpdate";
import Entry from "./components/Entry/Entry";
import { Faq } from "./components/Faqs/Faq";
import { FaqAdd } from "./components/Faqs/FaqAdd";
import { FaqEdit } from "./components/Faqs/FaqEdit";
import Navbar from "./components/Navbar/Navbar";
import Product from "./components/Product/Product";
import ProductAdd from "./components/Product/ProductAdd";
import ProductUpdate from "./components/Product/ProductUpdate";
import ProductVariant from "./components/Product/ProductVariant";
import { ProductListing } from "./components/ProductListing/ProductListing";
import SellerAdd from "./components/SellerLogos/SellerAdd";
import SellerLogos from "./components/SellerLogos/SellerLogos";
import SellerUpdate from "./components/SellerLogos/SellerUpdate";
import TestimonialAdd from "./components/Testimonials/TestimonialAdd";
import Testimonials from "./components/Testimonials/Testimonials";
import TestimonialUpdate from "./components/Testimonials/TestimonialUpdate";
import { UserCarts } from "./components/Users/Carts/UserCarts";
import { Users } from "./components/Users/Users";
import LoginPage from "./LoginPage/LoginPage";
import { CartDetails } from "./components/Users/Carts/CartDetails";
import { AllCarts } from "./components/Carts/AllCarts";
import { Groups } from "./components/Groups/Groups";
import { Orders } from "./components/Orders/Orders";
import { OrderDetails } from "./components/Orders/OrderDetails";
import { ProductOrder } from "./components/ProductOrder/ProductOrder";
import { ProductOrderDetails } from "./components/ProductOrder/ProductOrderDetails";
import { GenerateKit } from "./components/GenerateKit/GenerateKit";
import Team from "./components/Team/Team";
import TeamAdd from "./components/Team/TeamAdd";
import TeamUpdate from "./components/Team/TeamUpdate";

export function ProtectedRoute({ children }) {
  if (localStorage.getItem("user")) {
    return children;
  } else {
    return <Navigate to="/login" replace />;
  }
}

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <Routes>
          <Route
            path="/"
            exact
            element={
              <ProtectedRoute>
                <Entry />
              </ProtectedRoute>
            }
          />
          <Route
            path="/category"
            exact
            element={
              <ProtectedRoute>
                <Category />
              </ProtectedRoute>
            }
          />
          <Route
            path="/category/:id"
            exact
            element={
              <ProtectedRoute>
                <CategoryUpdate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/category/add"
            exact
            element={
              <ProtectedRoute>
                <CategoryAdd />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientlogos"
            exact
            element={
              <ProtectedRoute>
                <ClientLogos />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientlogos/:id"
            exact
            element={
              <ProtectedRoute>
                <ClientUpdate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientlogos/add"
            element={
              <ProtectedRoute>
                <ClientAdd />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientlogospage"
            exact
            element={
              <ProtectedRoute>
                <ClientLogosPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientlogospage/:id"
            exact
            element={
              <ProtectedRoute>
                <ClientPageUpdate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/clientlogospage/add"
            element={
              <ProtectedRoute>
                <ClientPageAdd />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sellerlogos"
            exact
            element={
              <ProtectedRoute>
                <SellerLogos />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sellerlogos/:id"
            exact
            element={
              <ProtectedRoute>
                <SellerUpdate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/sellerlogos/add"
            element={
              <ProtectedRoute>
                <SellerAdd />
              </ProtectedRoute>
            }
          />
          <Route
            path="/testimonials"
            exact
            element={
              <ProtectedRoute>
                <Testimonials />
              </ProtectedRoute>
            }
          />
          <Route
            path="/testimonials/add"
            exact
            element={
              <ProtectedRoute>
                <TestimonialAdd />
              </ProtectedRoute>
            }
          />
          <Route
            path="/testimonials/:id"
            exact
            element={
              <ProtectedRoute>
                <TestimonialUpdate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/products"
            exact
            element={
              <ProtectedRoute>
                <Product />
              </ProtectedRoute>
            }
          />
          <Route
            path="/product-listing"
            exact
            element={
              <ProtectedRoute>
                <ProductListing />
              </ProtectedRoute>
            }
          />
          <Route
            path="/products/add"
            exact
            element={
              <ProtectedRoute>
                <ProductAdd />
              </ProtectedRoute>
            }
          />
          <Route
            path="/products/add/:cartId"
            exact
            element={
              <ProtectedRoute>
                <ProductAdd />
              </ProtectedRoute>
            }
          />
          <Route
            path="/products/:id"
            exact
            element={
              <ProtectedRoute>
                <ProductUpdate />
              </ProtectedRoute>
            }
          />
          <Route
            path="/product/:id"
            exact
            element={
              <ProtectedRoute>
                <ProductVariant />
              </ProtectedRoute>
            }
          />
          <Route
            path="/catalogs"
            exact
            element={
              <ProtectedRoute>
                <Catalogs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/catalogs/:id"
            exact
            element={
              <ProtectedRoute>
                <CatalogDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/catalogs/:catalogId/products/:id"
            exact
            element={
              <ProtectedRoute>
                <AddEditProduct />
              </ProtectedRoute>
            }
          />
          <Route
            path="/catalogs/:catalogId/products/add"
            exact
            element={
              <ProtectedRoute>
                <AddEditProduct />
              </ProtectedRoute>
            }
          />

          <Route
            path="/blogs"
            element={
              <ProtectedRoute>
                <Blogs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/blogs/:id/edit"
            element={
              <ProtectedRoute>
                <CreateEditBlog />
              </ProtectedRoute>
            }
          />
          <Route
            path="/blogs/new"
            element={
              <ProtectedRoute>
                <CreateEditBlog />
              </ProtectedRoute>
            }
          />
          <Route
            path="/carts"
            exact
            element={
              <ProtectedRoute>
                <AllCarts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users"
            exact
            element={
              <ProtectedRoute>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users/:id/carts"
            exact
            element={
              <ProtectedRoute>
                <UserCarts />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users/:id/carts/:cartId"
            exact
            element={
              <ProtectedRoute>
                <CartDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <Orders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/product-order"
            element={
              <ProtectedRoute>
                <ProductOrder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/product-order/:id"
            element={
              <ProtectedRoute>
                <ProductOrderDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders/:id"
            element={
              <ProtectedRoute>
                <OrderDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/groups"
            element={
              <ProtectedRoute>
                <Groups />
              </ProtectedRoute>
            }
          />
          <Route
            path="/faqs"
            element={
              <ProtectedRoute>
                <Faq />
              </ProtectedRoute>
            }
          />
          <Route
            path="/faqs/add"
            element={
              <ProtectedRoute>
                <FaqAdd />
              </ProtectedRoute>
            }
          />
          <Route
            path="/faqs/:id/edit"
            element={
              <ProtectedRoute>
                <FaqEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/generate-kit"
            element={
              <ProtectedRoute>
                <GenerateKit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/team"
            element={
              <ProtectedRoute>
                <Team />
              </ProtectedRoute>
            }
          />
          <Route
            path="/team/add"
            element={
              <ProtectedRoute>
                <TeamAdd />
              </ProtectedRoute>
            }
          />
          <Route
            path="/team/:id"
            element={
              <ProtectedRoute>
                <TeamUpdate />
              </ProtectedRoute>
            }
          />
          <Route path="/login" element={<LoginPage />} />
        </Routes>
        <ToastContainer />
      </Router>
    </div>
  );
}

export default App;
